import React from "react";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShareIcon from "@mui/icons-material/Share";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import {
    Box,
    Grid,
    Card,
    CardMedia,
    CardContent,
    Typography,
    TextField,
    Button,
    Divider,
    List,
    ListItem,
    ListItemText,
    Breadcrumbs,
    Link,
    IconButton,
} from "@mui/material";
import { Pageheader } from "../global-components/page-header";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const PropertyNew = ({ property }) => {
    return (
        <>
            <Pageheader headertitle="About Us" isAbout />
            {/* <Box
                sx={{
                    width: "100%",
                    borderBottom: "1px solid #eee",
                    pb: 2,
                    pt: 1,
                }}
            >
            </Box> */}
            <div>
                <Box sx={{ px: { xs: 1, md: 4 }, backgroundColor: "#f9f9f9" }}>
                    {/* Breadcrumb + Title + Location (grouped in one grey box) */}
                    <Box
                        sx={{
                            backgroundColor: "#f2f2f2", // light grey background
                            p: { xs: 2, md: 3 },
                            borderRadius: 2,
                            mb: 3,
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
                            <Breadcrumbs
                                aria-label="breadcrumb"
                                separator={<NavigateNextIcon fontSize="small" sx={{ color: "#999" }} />}
                                sx={{
                                    '& ol': { listStyle: 'none !important', padding: 0, margin: 0 },
                                    '& ol li': { margin: 0, padding: 0 },
                                    '& ol li::marker': { display: 'none' },
                                    '& ol li::before': { content: '""', display: 'none' },
                                }}
                            >
                                <Link
                                    underline="hover"
                                    href="#"
                                    sx={{ display: "flex", alignItems: "center", color: "#0A7C3B !important", fontWeight: 600 }}
                                >
                                    <HomeOutlinedIcon sx={{ mr: 0.5, fontSize: 18 }} />
                                    Home
                                </Link>

                                <Link
                                    underline="hover"
                                    href="#"
                                    sx={{ color: "#0A7C3B !important", fontWeight: 600 }}
                                >
                                    Commercial Plot
                                </Link>

                                <Typography color="#444" sx={{ fontSize: 15 }}>
                                    500 Sq Yards Commercial Plot For Sale In Thullur
                                </Typography>
                            </Breadcrumbs>

                            {/* Icons on right */}
                            <Box sx={{ display: "flex", gap: 1 }}>
                                <IconButton size="small" sx={{ border: "1px solid #ddd", borderRadius: 1 }}>
                                    <FavoriteBorderIcon sx={{ fontSize: 20 }} />
                                </IconButton>
                                <IconButton size="small" sx={{ border: "1px solid #ddd", borderRadius: 1 }}>
                                    <ShareIcon sx={{ fontSize: 20 }} />
                                </IconButton>
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "space-between",
                                flexDirection: { xs: "column", md: "row" },
                                gap: 2,
                            }}
                        >
                            <Typography variant="h4" fontWeight={700} sx={{ wordBreak: "break-word", flex: 1 }}>
                                500 Sq Yards Commercial Plot For Sale In Thullur
                            </Typography>

                            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: { xs: 1, md: 0 } }}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Typography sx={{ color: "#0A7C3B", fontWeight: 600, fontSize: 14, mr: 1 }}>
                                        For the Latest Rates -
                                    </Typography>

                                    <Link
                                        href="tel:+91-XXXXXXXXXX"
                                        underline="none"
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            color: "#0A7C3B",
                                            fontWeight: 700,
                                            gap: 0.5,
                                        }}
                                    >
                                        <CallIcon sx={{ color: "#0A7C3B", fontSize: 18 }} />
                                        <Typography sx={{ color: "#0A7C3B", fontWeight: 600, fontSize: 14 }}>
                                            Call Now!
                                        </Typography>
                                    </Link>
                                </Box>

                                
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", color: "#666" }}>
                                    <LocationOnOutlinedIcon sx={{ fontSize: 18, mr: 0.5, color: "#777" }} />
                                    <Typography component="span" sx={{ fontSize: 15, color: "#444" }}>
                                        Thulluru
                                    </Typography>
                                </Box>
                        </Box>
                    </Box>

                    <Grid container spacing={4}>
                        {/* Left Section */}
                        <Grid item xs={12} md={8}>
                            {/* Image Card */}
                            <Card sx={{ borderRadius: 2 }}>
                                <CardMedia
                                    component="img"
                                    height="320"
                                    image="/sample.jpg" // Replace with actual image
                                    alt="Property"
                                />
                            </Card>

                            {/* Quick Info Panel */}
                            <Card sx={{ mt: 2, p: 2 }}>
                                <Grid container spacing={2} textAlign="center">
                                    <Grid item xs={3}>
                                        <Typography fontWeight={700}># 444</Typography>
                                        <Typography variant="body2">First Colony</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography fontWeight={700}>500 Sq Yards</Typography>
                                        <Typography variant="body2">Plot Size</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography fontWeight={700}>East</Typography>
                                        <Typography variant="body2">Facing</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography fontWeight={700}>12 Meters</Typography>
                                        <Typography variant="body2">Road</Typography>
                                    </Grid>
                                </Grid>
                            </Card>

                            {/* Description */}
                            <Box mt={4}>
                                <Typography variant="h5" fontWeight={600} mb={2}>
                                    Description
                                </Typography>

                                <Typography mb={2} lineHeight={1.7}>
                                    Amaravati’s Smart Investment: Secure Your East-Facing 500 Sq Yards Commercial Plot Today
                                    <br />
                                    It’s the right time to invest in Amaravati’s commercial heartbeat. Presenting a prime 500 Sq Yards
                                    commercial plot for sale in Thullur, perfectly positioned to deliver long-term growth and stability
                                    for your future ventures.
                                </Typography>

                                <Typography fontWeight={700} mb={1}>
                                    🔶 Key Highlights:
                                </Typography>
                                <Typography component="ul" sx={{ pl: 3 }}>
                                    <li>East-facing premium property, ideal for business development</li>
                                    <li>Located in Thullur—Amaravati’s bustling core</li>
                                    <li>Surrounded by Education Zones, Park Areas, and Parking Zones</li>
                                </Typography>
                            </Box>

                            {/* Similar Listings */}
                            <Box mt={5}>
                                <Typography variant="h5" fontWeight={600} mb={2}>
                                    Similar Listings
                                </Typography>

                                <Grid container spacing={3}>
                                    {[1, 2].map((item) => (
                                        <Grid item xs={12} md={6} key={item}>
                                            <Card sx={{ borderRadius: 2 }}>
                                                <CardMedia
                                                    component="img"
                                                    height="160"
                                                    image="/plot.jpg"
                                                    alt="Listing"
                                                />
                                                <CardContent>
                                                    <Typography fontWeight={700}>756 Sq Yards</Typography>
                                                    <Typography variant="body2">₹ 2.65 Cr</Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </Grid>

                        {/* Right Section – Sidebar */}
                        <Grid item xs={12} md={4}>
                            {/* Form */}
                            <Card sx={{ p: 3, borderRadius: 2 }}>
                                <Typography variant="h6" fontWeight={700} textAlign="center" mb={2}>
                                    ROYALE SPACES
                                </Typography>

                                <TextField fullWidth label="Name" size="small" sx={{ mb: 2 }} />
                                <TextField fullWidth label="Email" size="small" sx={{ mb: 2 }} />

                                <TextField
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    label="Message"
                                    size="small"
                                    sx={{ mb: 2 }}
                                    defaultValue={`Hello, I am interested in [500 Sq Yards Commercial Plot for Sale in Thullur]`}
                                />

                                <Typography variant="caption">
                                    By submitting this form I agree to Terms of Use
                                </Typography>

                                <Button
                                    fullWidth
                                    variant="contained"
                                    sx={{ mt: 2, py: 1.2, backgroundColor: "#007b55" }}
                                >
                                    Send Message
                                </Button>

                                <Button
                                    fullWidth
                                    variant="outlined"
                                    startIcon={<CallIcon />}
                                    sx={{ mt: 2, py: 1.2 }}
                                >
                                    Call
                                </Button>

                                <Button
                                    fullWidth
                                    variant="outlined"
                                    startIcon={<WhatsAppIcon />}
                                    sx={{ mt: 2, py: 1.2, borderColor: "#25D366", color: "#25D366" }}
                                >
                                    WhatsApp
                                </Button>
                            </Card>

                            {/* Latest Posts */}
                            <Box mt={4}>
                                <Typography variant="h6" fontWeight={600} mb={2}>
                                    Latest Posts
                                </Typography>

                                <List>
                                    {[
                                        "SRM University (SRM) Research Center Amaravati Leading A New Era In Healthcare And Innovation",
                                        "L&T Construction Skills Training Institute – A Catalyst for Growth.",
                                        "CIDB Approved Land Pooling Plots in Amaravati—Invest Smart Today",
                                        "Quantum Valley Amaravati – Leading the Capital City Growth",
                                    ].map((post, idx) => (
                                        <React.Fragment key={idx}>
                                            <ListItem disableGutters>
                                                <ListItemText primary={post} />
                                            </ListItem>
                                            {idx !== 3 && <Divider />}
                                        </React.Fragment>
                                    ))}
                                </List>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </div>

        </>
    )
}
export default PropertyNew;